// validation/categoryValidation.js

import * as Yup from "yup";

const MAX_FILE_SIZE = 1024 * 1024; // 1MB

const SUPPORTED_FORMATS = [
  "image/jpg",
  "image/jpeg",
  "image/png",
  "image/webp",
];

const RECOMMENDED_WIDTH = 800;
const RECOMMENDED_HEIGHT = 800;

// ================= IMAGE DIMENSION VALIDATION =================

const validateImageDimensions = (file) => {
  return new Promise((resolve) => {
    // NO FILE
    if (!file) {
      resolve(false);
      return;
    }

    // EDIT MODE STRING IMAGE
    if (typeof file === "string") {
      resolve(true);
      return;
    }

    // INVALID OBJECT
    if (!(file instanceof File)) {
      resolve(false);
      return;
    }

    const image = new Image();

    const reader = new FileReader();

    reader.onload = (e) => {
      image.src = e.target.result;
    };

    image.onload = () => {
      const isValid =
        image.width === RECOMMENDED_WIDTH &&
        image.height === RECOMMENDED_HEIGHT;

      resolve(isValid);
    };

    image.onerror = () => {
      resolve(false);
    };

    reader.readAsDataURL(file);
  });
};

export const categoryInitialValues = {
  type: {
    value: "category",
    label: "Category",
  },

  category: null,

  name: "",

  seq_no: 0,

  is_active: true,

  img_path: null,
};

export const catgSubValidationSchema = Yup.object().shape({
  type: Yup.object()
    .nullable()
    .required("Type is required"),

  category: Yup.object()
    .nullable()
    .when("type", {
      is: (type) =>
        type?.value === "subcategory",

      then: (schema) =>
        schema.required(
          "Main category is required"
        ),

      otherwise: (schema) =>
        schema.nullable(),
    }),

  name: Yup.string()
    .trim()
    .min(
      2,
      "Name must be at least 2 characters"
    )
    .max(255, "Max 255 characters allowed")
    .required("Name is required"),

  img_path: Yup.mixed()
    .required("Image is required")

    // FILE TYPE
    .test(
      "fileFormat",
      "Only JPG, JPEG, PNG, WEBP allowed",
      (value) => {
        // EXISTING IMAGE STRING
        if (typeof value === "string") {
          return true;
        }

        // NO FILE
        if (!value) {
          return false;
        }

        // INVALID FILE
        if (!(value instanceof File)) {
          return false;
        }

        return SUPPORTED_FORMATS.includes(
          value.type
        );
      }
    )

    // FILE SIZE
    .test(
      "fileSize",
      "Image size must be less than 1MB",
      (value) => {
        // EXISTING IMAGE STRING
        if (typeof value === "string") {
          return true;
        }

        if (!value) {
          return false;
        }

        if (!(value instanceof File)) {
          return false;
        }

        return value.size <= MAX_FILE_SIZE;
      }
    )

    // IMAGE DIMENSIONS
    .test(
      "fileDimensions",
      "Image must be exactly 800x800 px",
      async (value) => {
        return await validateImageDimensions(
          value
        );
      }
    ),
});